/**
 * 주소로 지목받은 한 건 — $j.F.Admin.TaskOpen
 *
 * 알림 모아보기(/adm/tasks)에서 「처리 화면으로 이동」을 누르면 도메인 화면으로 오는데,
 * **목록이 아니라 그 건을 가리키고 온다** — `…?open=<소스번호>` (`LedgerProvider::itemUrl`).
 * 목록만 던져주면 받은 사람이 방금 본 그 건을 다시 찾아야 하고, 페이지가 넘어가 있으면 못 찾는다.
 *
 *   // 페이지 모듈의 openFromQuery() 안에서 한 번
 *   const num = $j.F.Admin.TaskOpen.take();
 *   if (num) $j.F.Admin.Member.Leave.open(num);   // 담당 확인은 모달이 한다(TaskGuard)
 *
 * **주소는 한 번만 먹는다.** 값을 집으면서 주소에서 지운다(`history.replaceState`) —
 * 새로고침·뒤로가기에 판정창이 되살아나면 안 되고, 주소를 복사해 넘긴 사람의 화면에서
 * 담당 확인창이 뜨면 더 안 된다. 그래서 읽기(`peek`)와 집기(`take`)를 나눠 두었다.
 *
 * 규약은 .ai/domains/admin-task.md 「한 건을 여는 프로토콜」.
 */
export default class TaskOpen {

    /** 파라미터 이름 — 화면마다 다르면 새 종류를 붙일 때마다 수색이 된다 */
    static PARAM = 'open';

    /** 지우지 않고 보기만 한다 (열지 말지 아직 못 정한 자리) */
    static peek(param = TaskOpen.PARAM) {
        return Number(new URLSearchParams(location.search).get(param)) || 0;
    }

    /** 집는다 — 값을 돌려주고 주소에서 지운다. 없으면 0 */
    static take(param = TaskOpen.PARAM) {
        const num = TaskOpen.peek(param);
        if (num) TaskOpen.clear(param);

        return num;
    }

    /** 주소에서만 지운다 — 화면은 그대로다(새로고침 없음) */
    static clear(param = TaskOpen.PARAM) {
        const q = new URLSearchParams(location.search);
        if (!q.has(param)) return;

        q.delete(param);
        const qs = q.toString();
        history.replaceState(null, '', location.pathname + (qs ? '?' + qs : '') + location.hash);
    }
}
